import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { Container, Stack } from '@mui/material'
import { Scrollbar, Tree } from '~/components'
import { bshSlice } from '~/store'
import { useRouteContext } from '../hooks'

const ActionGuard = () => {
  const ready = useSelector(bshSlice.ready)
  const { action, location, subCategory, product } = useRouteContext(
    ActionGuard.name
  )

  const content = useMemo(() => {
    const component =
      action?.getComponent?.({ location, subCategory, product }) ??
      action?.component
    const container =
      action?.getContainer?.({ location, subCategory, product }) ??
      action?.container ??
      {}
    const withScrollbar =
      action?.getWithScrollBar?.({ location, subCategory, product }) ??
      action?.withScrollbar ??
      true
    const content = (
      <Container
        maxWidth="md"
        {...container}
        sx={{
          marginLeft: 0,
          marginRight: 0,
          py: 2,
          ...(container.sx ?? {}),
        }}
      >
        {component}
      </Container>
    )
    return ready ? (
      component ? (
        <Stack direction="row">
          <Tree />
          <Stack sx={{ position: 'relative', flexGrow: 1 }}>
            {withScrollbar ? (
              <Scrollbar
                className="absolute inset-0 overflow-hidden"
                options={{ suppressScrollX: true }}
              >
                {content}
              </Scrollbar>
            ) : (
              content
            )}
          </Stack>
        </Stack>
      ) : (
        <Container maxWidth={false} sx={{ py: 2 }}>
          <div className="h-full xy-center">
            Action: {action?.name ? JSON.stringify(action.name) : 'undefined'}
          </div>
        </Container>
      )
    ) : null
  }, [action, location, product, ready, subCategory])

  return (
    <>
      <Helmet title={action?.name} />
      {content}
    </>
  )
}

export default ActionGuard
